import { MeasureCell as MeasureCellComponent } from "../tabular/utils/measure-column/MeasureCell";

interface Props {
  formattedValue: string;
  disableCellClick: boolean;
}

const GrandTotalCell = ({ formattedValue, disableCellClick }: Props) => {
  return (
    <MeasureCellComponent
      variant="subtitle2"
      value={formattedValue}
      sx={{
        "&:hover": !disableCellClick
          ? {
              cursor: "pointer",
              textDecoration: "underline",
            }
          : {},
        ...(!disableCellClick && {
          textDecoration: "1px underline dashed #91A4B6",
          textUnderlineOffset: "15%",
        }),
      }}
    />
  );
};

export default GrandTotalCell;
